import React from 'react';
import { Button } from 'antd';
import ImportModal from './component/importModal';

class NewCsxImportCom extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ImportVisible: false,
    };
  }

  changeImportVisible = () => {
    const { ImportVisible } = this.state;
    this.setState({
      ImportVisible: !ImportVisible,
    });
  };
  render() {
    const { ImportVisible } = this.state;
    const { style, type, disabled = false, ...others } = this.props;

    return (
      <span>
        <Button
          style={style}
          onClick={this.changeImportVisible}
          type={type || 'primary'}
          disabled={disabled}>
          {this.props.children}
        </Button>
        {ImportVisible && (
          <ImportModal
            Visible={ImportVisible}
            changeImportVisible={this.changeImportVisible}
            {...others}
          />
        )}
      </span>
    );
  }
}

export default NewCsxImportCom;
